import { userDataActions } from 'app/store/actions/user-data.actions'
import { UserDataState } from 'app/types/user-data-reducer.types'
import { ReduxSagaAction } from 'app/types/store.types'
import { HUB_PROGRAMS } from 'app/constants/entitlement.constant'

const initialState: UserDataState = {
  currentGrade: '',
  grade: '',
  grades: [],
  kcInfo: {
    email: '',
    firstName: '',
    lastName: '',
    fullName: '',
    ampId: '',
    entitledLanguages: [],
    sessionUUID: null,
    businessKey: null,
    isTeacher: false,
    isStudent: false,
    permissions: [],
    isReadOnly: false,
    readers: [],
    roles: [],
  },
  loading: true,
  error: false,
  contentToken: '',
  hubPrograms: {
    [HUB_PROGRAMS.CKLA]: [],
    [HUB_PROGRAMS.CKLA3]: [],
    [HUB_PROGRAMS.CAMINOS]: [],
    [HUB_PROGRAMS.TEXAS_ELAR]: [],
    [HUB_PROGRAMS.TEXAS_SLAR]: [],
    [HUB_PROGRAMS.TEXAS_IMRA]: [],
    [HUB_PROGRAMS.TEXAS_IMRA_COMMERCIAL]: [],
  },
  filters: {},
}

function userDataReducer(
  // eslint-disable-next-line default-param-last
  state = initialState,
  action: ReduxSagaAction
): UserDataState {
  switch (action.type) {
    case userDataActions.SET_USER_GRADE.SUCCESS:
      return {
        ...state,
        grade: action.payload,
      }

    case userDataActions.SET_USER_GRADE.FAILURE:
      return {
        ...state,
        error: action.payload.error,
      }

    case userDataActions.GET_USER_DATA.REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      }

    case userDataActions.GET_USER_DATA.SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        ...action.payload,
      }

    case userDataActions.GET_USER_DATA.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      }
    default:
      return state
  }
}

export default userDataReducer
